import { useEffect, useState } from "react";
import Table from "../../components/admin/Table";
import { studentsData } from "../../assets/studentsData";
import { useNavigate } from "react-router-dom";

export default function AllStudents() {
  const [allStudents, setAllStudents] = useState([]);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  useEffect(() => {
    if (user.role !== "ADMIN") {
      localStorage.removeItem("user");
      navigate("/login");
      return;
    }
  }, []);
  useEffect(() => {
    setAllStudents(studentsData);
    apiCall();
  }, []);

  async function apiCall() {}

  // Change page number
  const paginate = async (pageNumber) => {
    // const pendingPostsRes = await getPendingPostsForAdmin(pageNumber);
    // if (pendingPostsRes?.status === 200) {
    //   var data = pendingPostsRes?.data;
    //   setUnPublishedPosts(pendingPostsRes?.data?.posts);
    //   setCurrentPage(pageNumber);
    // }
  };
  return (
    <div className="pb-10">
      <Table
        tableTitle={"All Students"}
        data={allStudents}
        setData={setAllStudents}
        columns={["Student Name", "Student ID", "Email", "DoB", "Action"]}
        forAllStudents={true}
      />
    </div>
  );
}
